import { FONT_SIZE } from './font-size';
export const LINE_HEIGHT_TOKEN = ['DEFAULT', 'LOOSE', 'AUTO'];
export const LINE_HEIGHT = {
    A_DEFAULT: 12,
    B_DEFAULT: 12,
    C_DEFAULT: 12,
    D_DEFAULT: 16,
    E_DEFAULT: 16,
    F_DEFAULT: 20,
    G_DEFAULT: 24,
    H_DEFAULT: 24,
    I_DEFAULT: 28,
    J_DEFAULT: 28,
    K_DEFAULT: 32,
    L_DEFAULT: 40,
    M_DEFAULT: 40,
    N_DEFAULT: 48,
    O_DEFAULT: 56,
    P_DEFAULT: 60,
    Q_DEFAULT: 64,
    R_DEFAULT: 72,
    S_DEFAULT: 72,
    T_DEFAULT: 88,
    U_DEFAULT: 96,
    V_DEFAULT: 104,
    W_DEFAULT: 120,
    X_DEFAULT: 128,
    Y_DEFAULT: 152,
    Z_DEFAULT: 160,
    // Loose leading
    A_LOOSE: 16,
    B_LOOSE: 16,
    C_LOOSE: 16,
    D_LOOSE: 20,
    E_LOOSE: 20,
    F_LOOSE: 24,
    G_LOOSE: 28,
    H_LOOSE: 28,
    I_LOOSE: 32,
    J_LOOSE: 32,
    K_LOOSE: 40,
    L_LOOSE: 48,
    M_LOOSE: 48,
    N_LOOSE: 56,
    O_LOOSE: 60,
    P_LOOSE: 64,
    Q_LOOSE: 72,
    R_LOOSE: 80,
    S_LOOSE: 80,
    T_LOOSE: 96,
    U_LOOSE: 104,
    V_LOOSE: 120,
    W_LOOSE: 128,
    X_LOOSE: 144,
    Y_LOOSE: 160,
    Z_LOOSE: 172,
    // Auto leading
    A_AUTO: FONT_SIZE.A,
    B_AUTO: 10,
    C_AUTO: FONT_SIZE.C,
    D_AUTO: 12,
    E_AUTO: 14,
    F_AUTO: FONT_SIZE.F,
    G_AUTO: FONT_SIZE.G,
    H_AUTO: FONT_SIZE.H,
    I_AUTO: FONT_SIZE.I,
    J_AUTO: FONT_SIZE.J,
    K_AUTO: FONT_SIZE.K,
    L_AUTO: FONT_SIZE.L,
    M_AUTO: FONT_SIZE.M,
    N_AUTO: FONT_SIZE.N,
    O_AUTO: FONT_SIZE.O,
    P_AUTO: FONT_SIZE.P,
    Q_AUTO: FONT_SIZE.Q,
    R_AUTO: FONT_SIZE.R,
    S_AUTO: FONT_SIZE.S,
    T_AUTO: FONT_SIZE.T,
    U_AUTO: FONT_SIZE.U,
    V_AUTO: FONT_SIZE.V,
    W_AUTO: FONT_SIZE.W,
    X_AUTO: FONT_SIZE.X,
    Y_AUTO: FONT_SIZE.Y,
    Z_AUTO: FONT_SIZE.Z,
    // Other leadings
    NONE: 0,
};
